<style scoped>
  .expand-row{
    margin-bottom: 16px;
  }
</style>
<template>
  <div>
    <Table :columns="columns" :data="rows" :show-header="true"></Table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ExpandRow',
  props: {
    mobile: String
  },
  data () {
    return {
      rows: [],
      columns: [
        {
          title: '会议',
          key: 'meetingName'
        },
        {
          title: '报名时间',
          key: 'attendeeDate',
          render: (h, params) => {
            return h('span', this.formatDate(params.row.attendeeDate))
          }
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '公司',
          key: 'companyName'
        },
        {
          title: '邮箱',
          key: 'email'
        }
      ]
    }
  },
  methods: {
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return null
      }
    }
  },
  async created () {
    try {
      this.$Loading.start()
      let resp = await this.$http.get(`/api/admin/meetings/mine/attendees/history?mobile=${this.mobile}`)
      this.rows = resp.body
      this.$Loading.finish()
    } catch (e) {
      console.log(e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/attendee/ExpandRow.vue